import NotFound from "./notFound.container";

export default NotFound;
